
import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { SettingsUserSelectorV1Field } from "../settings-user-selector-v1.class";

import { ThreeDotsMenuItem } from '@core/components/helpers/navigation/three-dots-menu/three-dots-menu-item';

import { FormsFieldItemMenuClick } from '../../../settings-field-menu/field-menu-item.model';
import { FieldsStandardRemoveMenuItem, FieldsMenuMoveDown,  FieldsMenuMoveUp, FieldsMenuReallyRemove } from '../../../settings-field-menu/fields.menu';
@Component({
    selector: 'form-field-settings-user-selector-v1',
    templateUrl: './settings-user-selector-v1.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SettingsUserSelectorV1FieldComponent implements OnInit, OnChanges{
    @Input() field: SettingsUserSelectorV1Field;
    @Output() fieldChange = new EventEmitter<SettingsUserSelectorV1Field>();
    @Output() menuClick = new EventEmitter<FormsFieldItemMenuClick>();

    public placeholder: string = "Name of the User Name field";
    public form: FormGroup = new FormGroup({});
    public fieldMenu: Array<ThreeDotsMenuItem> = [...FieldsStandardRemoveMenuItem, FieldsMenuMoveDown,  FieldsMenuMoveUp];

    constructor(private cdr: ChangeDetectorRef) {}

    ngOnInit(): void {
    }
    
    ngOnChanges(changes: SimpleChanges): void {
        if(changes.field){
            this.cdr.markForCheck();
        }
    }

    onMandatoryChange(mandatory: boolean) {
        // Create a new object to ensure change detection
        this.field = this.field.update({ mandatory: mandatory});
        this.emit(this.field);;
    }

    onFieldChange(labelText: string) {
        this.emit(this.field.update({ label: labelText}));
    }

    onMenuClick(key: string) {
        // see ThreeDotsMenuItem interface definition to see how works this confirmation remove
        switch(key) {
            case "confirmation-remove":
                this.fieldMenu = [FieldsMenuMoveDown,  FieldsMenuMoveUp, FieldsMenuReallyRemove];
                break;
            case "dismiss-really-remove": // pseudo key to return to basic menu
                this.fieldMenu = [...FieldsStandardRemoveMenuItem, FieldsMenuMoveDown,  FieldsMenuMoveUp];
                break;
            default:
                const itemClicked: FormsFieldItemMenuClick = {key: key, field: this.field}
                this.menuClick.emit(itemClicked);
        }
    }

    private emit(updatedField: SettingsUserSelectorV1Field): void {
        this.fieldChange.emit(updatedField);
    }
}   